import '../styles/r-and-d-styles.css'

function LoadResearchAndDevelopment() {
    return (
        <div className="container" id="research-and-development">
            <div>
                <h2>Innovation Spotlight: Al in Healthcare</h2>
                <p>We are committed to exploring how Al can solve critical global challenges. Our proof-of-concept for Diabetic Foot Ulcer (DFU) monitoring is a testament to this mission.</p>
            </div>

            <div className='card'>
                <div>
                    <h2>The challenge</h2>
                    <p>
                        DFUs are a severe diabetes complication with high risks of limb loss and mortality.
                        Early, accessible, and affordable diagnosis is critical but often lacking, especially in underserved regions.
                    </p>
                </div>

                <div>
                    <h2>Our Concept</h2>
                    <p>
                        We developed a proof-of-concept using transfer learning to create a cheap, easy-to-use tool for diagnosing and monitoring DFUs. This demonstrates our ability to rapidly apply advanced Al to pressing medical needs.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default LoadResearchAndDevelopment;